module.exports = __webpack_public_path__ + "img/ios二维码.7bfd538b.png";